// extracted by mini-css-extract-plugin
export default {"bestBox":"styles_bestBox__lOWB5","people":"styles_people__Paj8X"};